import React, { Component } from 'react';
import { TextInput } from '../shared/TextInput'
import BankAccountSettingsForm from './bank_account_form'

export default class BankAccount extends Component {

  buttonText = (create, bankAccountInfo) => {
    if (bankAccountInfo) return 'Cancel Bank Account Update'
    return create
      ? 'Enter Bank Account Information'
      : 'Update Bank Account Information'
  }

  render() {
    return (
      <div>
        <button type='button' onClick={this.props.toggleBankAccountInfo} className='alt-button setting-form' >
          { this.buttonText(this.props.create, this.props.bankAccountInfo) }
        </button>
        { this.props.bankAccountInfo &&
          <BankAccountSettingsForm
            create={ this.props.create }
          />
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Settings/BankAccount.jsx